<template>
  <div
    id="footer_section"
    data-test-id="footer_section"
    class="py-1 px-3 bg-blue-dark text-white-50"
  >
    <span>Copyright &copy; TinyURL LLC</span>

    &nbsp;&bull;&nbsp;

    <router-link
      :to="{ name: 'terms' }"
      class="text-nowrap"
    >
      Terms
    </router-link>

    &nbsp;&bull;&nbsp;

    <router-link
      :to="{ name: 'privacy' }"
      class="text-nowrap"
    >
      Privacy Policy
    </router-link>

    &nbsp;&bull;&nbsp;

    <a
      data-test-id="footer_link_accessibility"
      href="javascript:void(0)"
      class="text-nowrap"
      @click="showAccesibility"
    >
      Accessibility
    </a>

    <template v-if="isFreestarEnabled && isFreestarVisible">
      &nbsp;&bull;&nbsp;
      <button id="pmLink">
        Privacy Manager
      </button>
    </template>

    <template v-if="isCookieConsentEnabled">
      &nbsp;&bull;&nbsp;
      <a
        data-test-id="footer_link_privacy_cookie_settings"
        href="javascript:void(0)"
        class="text-nowrap"
        @click="showConsentSettings"
      >
        Privacy and cookie settings
      </a>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Accessibility from "@Modals/Accessibility.vue";
import PersonalInformationWarning from "@Modals/PersonalInformationWarning.vue";

export default {
  name: "AppFooter",

  props: {
    isCookieConsentEnabled: {
      type: Boolean,
      default: false,
    },

    isFreestarVisible: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters(["isFreestarEnabled"]),
  },

  methods: {
    showAccesibility() {
      Bus.$emit("showModal", Accessibility);
    },

    showPersonalInformationWarning() {
      Bus.$emit("showModal", PersonalInformationWarning);
    },

    showConsentSettings() {
      if (window.googlefc && googlefc.callbackQueue) {
        googlefc.callbackQueue.push(googlefc.showRevocationMessage);
      } else {
        console.error("Consent manager is not loaded. You might not be in a region where it's required.");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a,
button {
  color: #8290a1 !important;
  font-weight: 500;
}

#pmLink {
  background: transparent;
  border: none;
  cursor: pointer;
  font-weight: 600;
  padding: 0;
  text-decoration: none;
  visibility: hidden;

  &:hover {
    visibility: visible;
  }
}
</style>
